import { createReducer, on } from '@ngrx/store';
import { SubmissionDetails } from 'ngx-esprio-shared';
import { SubmissionsMap } from '../../../shared/models/responses/get-submissions-response.modal';
import { SubmissionApiActions } from '../actions/user-submissions-api.actions';

export interface UserSubmissionState {
  submissions: SubmissionsMap;
  submissionDetails: SubmissionDetails | null;
  latestSubmissionDetails: SubmissionDetails | null;
}

const initialState: UserSubmissionState = {
  submissions: {},
  submissionDetails: null,
  latestSubmissionDetails: null,
};

export const userSubmissionsReducer = createReducer(
  initialState,
  on(SubmissionApiActions.getSubmissionsSuccess, (state, { payload }) => ({
    ...state,
    submissions: payload.submissions,
  })),

  on(SubmissionApiActions.getSubmissionDetailsSuccess, (state, { payload }) => ({
    ...state,
    submissionDetails: payload,
  })),

  on(SubmissionApiActions.loadLatestSubmissionDetailsSuccess, (state, { payload }) => ({
    ...state,
    latestSubmissionDetails: payload,
  })),

  on(SubmissionApiActions.clearSubmissionDetails, (state) => ({
    ...state,
    submissionDetails: null,
  }))
);
